(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["free-balaclava-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    const offer = document.querySelector('[data-balaclava-gift]');
    if (!offer || offer.dataset.initialized === 'true') return;
    offer.dataset.initialized = 'true';
    const image = offer.querySelector('[data-balaclava-image]');
    const closeButton = offer.querySelector('[data-balaclava-close]');
    let images = [];
    let hideTimer;
    let repeatTimer;
    let dismissed = false;

    try { images = JSON.parse(offer.dataset.images || '[]'); } catch (error) { images = []; }

    let previousIndex = Number.parseInt(sessionStorage.getItem('freeBalaclavaImage') || '-1', 10);
    let currentIndex = Math.floor(Math.random() * images.length);
    if (images.length > 1 && currentIndex === previousIndex) {
      currentIndex = (currentIndex + 1 + Math.floor(Math.random() * (images.length - 1))) % images.length;
    }

    const selectImage = () => {
      if (!images.length) return;
      image.src = images[currentIndex];
      sessionStorage.setItem('freeBalaclavaImage', String(currentIndex));
      currentIndex = (currentIndex + 1) % images.length;
    };
    const hideOffer = () => {
      offer.classList.remove('is-visible');
      offer.setAttribute('aria-hidden', 'true');
    };
    const showOffer = () => {
      if (dismissed) return;
      selectImage();
      offer.classList.add('is-visible');
      offer.setAttribute('aria-hidden', 'false');
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(hideOffer, 5000);
    };

    closeButton.addEventListener('click', () => {
      dismissed = true;
      window.clearTimeout(hideTimer);
      window.clearInterval(repeatTimer);
      hideOffer();
    });

    window.setTimeout(() => {
      showOffer();
      repeatTimer = window.setInterval(showOffer, 15000);
    }, 4500);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["halloween-race-intro"] && !Shopify.designMode) return;
  try {
    (() => {
    const intro = document.querySelector('[data-halloween-race-intro]');
    if (!intro || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    try {
      if (window.sessionStorage.getItem('halloweenRaceIntroSeen') === 'true') return;
      window.sessionStorage.setItem('halloweenRaceIntroSeen', 'true');
    } catch (error) {}
    intro.hidden = false;
    const smoke = intro.querySelector('[data-race-smoke]');
    const skip = intro.querySelector('[data-race-intro-skip]');
    let smokeInterval;
    let audioContext;
    let engineGain;
    let soundStarted = false;

    const startSound = async () => {
      if (soundStarted || !intro.isConnected) return;
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      if (!AudioContext) return;
      if (!audioContext) audioContext = new AudioContext();
      if (audioContext.state === 'suspended') await audioContext.resume();
      if (audioContext.state !== 'running') return;
      soundStarted = true;
      const primary = audioContext.createOscillator();
      const secondary = audioContext.createOscillator();
      engineGain = audioContext.createGain();
      const filter = audioContext.createBiquadFilter();
      primary.type = 'sawtooth';
      secondary.type = 'square';
      primary.frequency.setValueAtTime(62, audioContext.currentTime);
      primary.frequency.exponentialRampToValueAtTime(190, audioContext.currentTime + 4.1);
      secondary.frequency.setValueAtTime(31, audioContext.currentTime);
      secondary.frequency.exponentialRampToValueAtTime(95, audioContext.currentTime + 4.1);
      filter.type = 'lowpass';
      filter.frequency.setValueAtTime(520, audioContext.currentTime);
      filter.frequency.exponentialRampToValueAtTime(1450, audioContext.currentTime + 4);
      engineGain.gain.setValueAtTime(.0001, audioContext.currentTime);
      engineGain.gain.exponentialRampToValueAtTime(.07, audioContext.currentTime + .2);
      engineGain.gain.exponentialRampToValueAtTime(.0001, audioContext.currentTime + 4.35);
      primary.connect(filter);
      secondary.connect(filter);
      filter.connect(engineGain);
      engineGain.connect(audioContext.destination);
      primary.start();
      secondary.start();
      primary.stop(audioContext.currentTime + 4.4);
      secondary.stop(audioContext.currentTime + 4.4);
    };

    const createSmoke = () => {
      const puff = document.createElement('span');
      puff.style.setProperty('--smoke-size', `${22 + Math.random() * 38}px`);
      puff.style.setProperty('--smoke-drift', `${35 + Math.random() * 55}px`);
      smoke.appendChild(puff);
      window.setTimeout(() => puff.remove(), 1400);
    };

    const finish = () => {
      window.clearInterval(smokeInterval);
      if (engineGain && audioContext) engineGain.gain.setTargetAtTime(.0001, audioContext.currentTime, .03);
      intro.style.opacity = '0';
      window.setTimeout(() => intro.remove(), 500);
    };

    smokeInterval = window.setInterval(createSmoke, 105);
    startSound().catch(() => {});
    window.addEventListener('pointerdown', () => startSound().catch(() => {}), { once: true });
    window.addEventListener('keydown', () => startSound().catch(() => {}), { once: true });
    skip.addEventListener('click', finish);
    window.setTimeout(finish, 5000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-customization-fields"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-customization')) {
    customElements.define('product-customization', class ProductCustomization extends HTMLElement {
      connectedCallback() {
        this.fields = this.querySelector('[data-customization-fields]');
        this.inputs = Array.from(this.querySelectorAll('[data-customization-input]'));
        this.querySelectorAll('[data-customization-toggle]').forEach((radio) => {
          radio.addEventListener('change', () => this.update(radio.value === 'Yes'));
        });
      }

      update(enabled) {
        this.fields.hidden = !enabled;
        this.inputs.forEach((input) => {
          input.disabled = !enabled;
          input.required = enabled;
          if (!enabled) input.value = '';
        });
        if (enabled) this.inputs[0].focus();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sale-promo-notifications"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.querySelector('[data-halloween-popup]');
    if (!popup) return;
    const endsAt = Date.parse('2026-10-18T23:59:59+05:00');
    let timer;
    const close = () => {
      window.clearTimeout(timer);
      popup.hidden = true;
      document.removeEventListener('keydown', onKey);
    };
    const onKey = (event) => { if (event.key === 'Escape') close(); };
    const start = () => {
      if (Date.now() > endsAt) return;
      popup.hidden = false;
      document.addEventListener('keydown', onKey);
      timer = window.setTimeout(close, 4000);
    };
    popup.querySelector('[data-halloween-close]').addEventListener('click', close);
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
